module.exports = __webpack_public_path__ + "media/images/landing/logo-mybenefits-636405258652f43a6474542dd4e53338.svg";